import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useApi } from '../lib/useApi';
import { Placeholder } from './Placeholder';
import { MatchNav } from './MatchNav';
const Loading = () => _jsx(Placeholder, { height: 230 }, void 0);
export const GetMatchNav = ({ matchUrl }) => {
    const { data, error, loading } = useApi(matchUrl);
    if (loading)
        return _jsx(Loading, {}, void 0);
    if (error) {
        // Send the error to Sentry and then prevent the element from rendering
        window.guardian.modules.sentry.reportError(error, 'match-nav');
        return null;
    }
    if (data) {
        return (_jsx(MatchNav, { homeTeam: data.homeTeam, awayTeam: data.awayTeam, comments: data.comments }, void 0));
    }
    return null;
};
